import Text from '../../Atoms/Text';
import Title from '../../Atoms/Title';
import Image from '../../Atoms/Image';
import Button from '../../Atoms/Button';
import CardBenefits from '../../Molecules/CardBenefits';
import LogoList from '../../Molecules/LogoList';
import ImageCarousel from '../../Molecules/ImageCarousel';
import CardContact from '../../Molecules/CardContact';
import {
  CardWorkspaceList,
  Props as CardWorkspaceProps
} from '../../Molecules/CardWorkspace';
import AccordionHorizontal, {
  Props as AccordionProps
} from '../../Molecules/AccordionHorizontal';
import CardReviewSlider from '../../Organisms/CardReviewSlider';
import BlockImageCenter from '../../Organisms/BlockImageCenter';
import BlockEmployer from '../../Organisms/BlockEmployer';

import heroBg from '../../../assets/img/candidate-bg.png';
import robot from '../../../assets/img/robot.png';
import bgMesh from '../../../assets/img/mesh_blue.png';
import { cards2 as cards } from '../../../data/cardWorkspacesListData';
import reviews from '../../../data/cardReviewSliderData';
import {
  slides,
  logos
} from '../../../data/logosListAndImageSliderData';
import elements from '../../../data/accordionHorizontalData';

function Candidate() {
  return (
    <>
      <div className="relative bg-white pt-24 pb-12 md:pb-28 md:pt-44">
        <div className="relative z-20 mx-auto w-full max-w-7xl px-7">
          <div className="flex flex-col-reverse items-stretch justify-center gap-7 md:flex-row">
            <div className="w-full md:w-1/2 md:pt-10">
              <Text font="circular">
                <span className="mb-5 text-lg md:text-xl lg:text-2xl">
                  Synsel Techniek
                </span>
              </Text>
              <Title
                as="h1"
                leading="none"
                className="mb-8"
              >
                <span>
                  Level up <b>your job</b>
                </span>
              </Title>
              <Button
                text="Bekijk alles"
                color="accent"
                shadow
              />
            </div>
            <div className="flex w-full items-center justify-center md:w-1/2">
              <Image src={robot} alt="Robot" />
            </div>
          </div>
          <div className="mt-12 grid w-full grid-cols-1 items-start justify-between gap-7 lg:grid-cols-3 lg:gap-3">
            <CardBenefits
              title="Be one of a kind"
              text="Zorgt voor een vliegende start van je carrière."
              icon="rocket-regular"
            />
            <CardBenefits
              title="Have fun together"
              text="Naast de beste baan ook nog eens de beste voorwaarden."
              icon="file-contract-regular"
            />
            <CardBenefits
              title="Move forward"
              text="Een vaste baan zorgt ervoor dat werkgevers investeren in jouw ontwikkeling."
              icon="lock-keyhole-regular"
            />
          </div>
        </div>
        <div className="pointer-events-none absolute inset-0 overflow-hidden">
          <img
            src={heroBg}
            alt="description"
            className="absolute left-0 bottom-0 h-full max-h-[670px] w-full object-bottom duration-300"
          />
        </div>
      </div>
      <div
        className="bg-sl-blue py-10 lg:py-24"
        style={{
          backgroundImage: `linear-gradient(225deg,#0E1C6B 0%,#23275B 100%)`
        }}
      >
        <div className="relative z-20 mx-auto w-full px-7">
          <Title
            as="h2"
            size={2}
            color="white"
            className="mb-3 text-center"
          >
            Kies je werkgebied
          </Title>
          <CardWorkspaceList
            elemInRow={4}
            cards={cards as CardWorkspaceProps[]}
          />
          <div className="mt-10 flex items-center justify-center">
            <Button
              text="Kies uit 4185 technische vacatures"
              color="white-outline"
              iconName="grid"
            />
          </div>
        </div>
      </div>

      <div
        className="bg-white py-10 lg:py-24"
        style={{
          backgroundImage:
            'linear-gradient(to bottom,#f4f4f7,#f7f7f9,#faf9fb,#fcfcfd,#ffffff)'
        }}
      >
        <div className="mx-auto w-full max-w-7xl px-7">
          <div className="grid grid-cols-1 items-center gap-3 gap-x-16 lg:grid-cols-2">
            <div className="w-full">
              <Text font="circular">
                <span className="mb-5 text-lg md:text-xl lg:text-2xl">
                  Kies voor keuze
                </span>
              </Text>

              <Title as="h2" size={2} className="mb-5">
                Wij zoeken naar de beste baan binnen jou
                ambitie
              </Title>
              <Button
                text="Lees de ervaringen"
                color="primary"
                shadow
              />
              <LogoList
                images={logos}
                className="py-10 lg:pt-20 lg:pb-10"
              />
            </div>
            <div className="w-full">
              <Text>
                Als je 1/3de deel van je dag doorbrengt op
                je werk, zorg dan voor een leuke uitdagende
                baan passend bij jouw ambities. Gelukkig heb
                jij als starter met als opleiding
                elektrotechniek, werktuigbouwkunde of
                mechatronica veel keuze op de huidige
                arbeidsmarkt. Synsel Techniek ziet dat er
                steeds vaker (te) snel gekozen wordt voor
                het eerste aanbod. Kies voor keuze en zorg
                voor een vliegende start van je carrière.
              </Text>
            </div>
          </div>
        </div>

        <ImageCarousel slides={slides} />

        <div className="md:px-7">
          <div
            className="w-full overflow-hidden py-10 md:rounded-xl md:py-20"
            style={{
              backgroundImage:
                'linear-gradient(180deg,rgba(244,244,247,0) 0%,#f4f4f7 100%)'
            }}
          >
            <div className="mx-auto w-full max-w-7xl px-7">
              <Title
                as="h2"
                size={2}
                className="mb-5 text-center"
              >
                Waarom wij de beste zijn voor technische
                kandidaten
              </Title>
              <BlockImageCenter
                image={robot}
                leftSide={[
                  {
                    title: 'De beste volgende stap',
                    text: 'Met een brede keuze uit banen kiezen we met elkaar de carrièrestap waarmee je bouwt aan jouw toekomst.',
                    icon: 'rocket-regular'
                  },
                  {
                    title: '+2500 innovatieve werkgevers',
                    text: 'Door ons uitgebreide netwerk bieden we jou als (Field) Service Engineer de grootste keuze aan als het gaat om werkgevers.',
                    icon: 'handshake-regular'
                  },
                  {
                    title: 'De beste voorwaarden',
                    text: 'Een goed salaris, prettige werksfeer en een goed bereikbare locatie: de beste baan voor jou heeft ook de beste voorwaarden.',
                    icon: 'file-contract-regular'
                  }
                ]}
                rightSide={[
                  {
                    title: 'Altijd vaste banen',
                    text: 'Echt bouwen aan jouw carrière doe je door te investeren in je toekomst met een vaste baan.',
                    icon: 'lock-keyhole-regular'
                  },
                  {
                    title: 'Werken met specialisten',
                    text: 'Bij Synsel Techniek verstaan we jouw technische vak. We kennen de markt, spreken jouw taal enweten wat er speelt.',
                    icon: 'screwdriver-wrench-regular'
                  },
                  {
                    title: 'Jij staat voorop',
                    text: 'Niet de werkgever maar jij staat voorop. Wij geloven erin dat als jij excelleert in jouw vak, onze klanten het meest tevreden zijn.',
                    icon: 'user-shield-regular'
                  }
                ]}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white py-10 lg:py-10">
        <div className="mx-auto w-full max-w-7xl px-7">
          <Title
            as="h2"
            size={2}
            className="mb-5 text-center"
          >
            <span>
              Onze werkwijze voor <br /> jou
            </span>
          </Title>
          <AccordionHorizontal
            elements={
              elements as AccordionProps['elements']
            }
            className="pt-5"
          />
        </div>
      </div>

      <BlockEmployer />

      <div className="relative flex flex-col bg-sl-indigo pt-16 pb-10 lg:pt-28 lg:pb-56">
        <div className="relative z-20 mx-auto w-full max-w-7xl px-7">
          <Title
            as="h2"
            className="text-center"
            color="white"
          >
            <span>Deze techneuten gingen je voor</span>
          </Title>
        </div>
        <div className="overflow-hidden lg:mt-12">
          <CardReviewSlider reviewList={reviews} />
        </div>
        <div className="pointer-events-none absolute inset-0 z-0">
          <Image
            src={bgMesh}
            alt="description"
            className="absolute bottom-0 left-0 w-full"
          />
        </div>
      </div>

      <div className="relative bg-white py-10 lg:py-10">
        <div className="mx-auto w-full max-w-7xl px-7">
          <Title as="h2" className="text-center">
            Wij staan voor je klaar
          </Title>

          <div className="grid gap-3 py-5 sm:grid-cols-2 sm:gap-5 md:grid-cols-4 lg:gap-7">
            <CardContact
              title="Bel"
              description="Direct contact"
              text="088 - 3231300"
              icon="phone"
              urlType="tel"
              url="#!"
            />
            <CardContact
              title="Chat"
              description="Direct antwoord"
              text="Chat met ons"
              icon="comments"
              url="#!"
            />
            <CardContact
              title="App"
              description="Binnen 2 uur reactie"
              text="0619734306"
              icon="whatsapp"
              url="#!"
            />
            <CardContact
              title="Mail"
              description="Binnen 1 dag reactie"
              text="talent@synsel.nl"
              icon="mail"
              url="#!"
              urlType="mail"
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default Candidate;
